// "PO1784…", "po-1784", "PO 1784" or a bare "PO" are already labelled; a
// word that only starts with the letters ("Pottery order") is not.
const ALREADY_PREFIXED_PO = /^po(?:\b|[\s\-#:.]*(?=\d))/i

/**
 * "PO 1784" for a bare number; a number that already starts with PO is kept
 * as it is, never doubled. Same rule as Express `formatOlliePurchaseOrder`.
 *
 * @param {string|number|null|undefined} purchaseOrderNumber
 * @returns {string} '' when there is no number
 */
export const formatPurchaseOrderLabel = purchaseOrderNumber => {
  const po = String(purchaseOrderNumber ?? '').trim()
  if (!po) return ''
  return ALREADY_PREFIXED_PO.test(po) ? po : `PO ${po}`
}
